import React from "react";
import {
  FaPhoneAlt,
  FaMapMarkerAlt,
  FaInstagram,
  FaFacebookF,
  FaYoutube,
} from "react-icons/fa";
import Logo from "../Logo";

export default function Header({ appState }) {
  const studio = appState?.adminDetails;

  return (
    <header className="relative bg-[#0f0f0f] text-white border-b border-yellow-600/30 shadow-lg">
      {/* Golden Top Line */}
      <div className="h-[3px] w-full bg-gradient-to-r from-transparent via-yellow-500 to-transparent" />
       <div className="md:absolute md:p-4 p-4">
          <Logo />
          </div>
      <div className="max-w-7xl mx-auto px-6 py-6">
        {/* Studio Name */}
        <div className="text-center">
          <h1 className="text-2xl md:text-5xl  tracking-[6px] uppercase text-white">
            {studio?.companyName || "VIDMANTRA"}
          </h1>

          <div className="flex items-center justify-center gap-3 mt-3">
            <div className="h-px w-16 bg-yellow-500" />
            <p className="text-yellow-500 uppercase tracking-[5px] text-xs">
              Photography • Films • Weddings
            </p>
            <div className="h-px w-16 bg-yellow-500" />
          </div>
        </div>

      <div className="mt-4 flex justify-center">
    <a
      href={`tel:${studio?.phone}`}
      className="inline-flex items-center gap-3 bg-yellow-500 text-black px-8 py-3 rounded-full font-semibold hover:scale-105 transition"
    >
      <FaPhoneAlt />
      {studio?.phone}
    </a>
  </div>
      </div>

      {/* Golden Bottom Line */}
      <div className="h-[3px] w-full bg-gradient-to-r from-transparent via-yellow-500 to-transparent" />
    </header>
  );
}